import { defineComponent } from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import usePayment from '@/usePayment';
import useDelivery from '@/useDelivery';

import DeliveryStatusRenderer from '@/components/Delivery/DeliveryStatusRenderer.vue';

const { translate: paymentMethodTranslate } = usePayment();
const { typeTranslate } = useDelivery();

export const _primaryControls = {
  width: '3rem',
};

export const _increment = {
  name: 'ลำดับ',
  width: '3rem',
  class: 'text-center',
};
export const orderNumber = {
  name: 'เลขที่รายการ',
  width: '8rem',
};
export const orderDate = {
  name: 'สั่งซื้อวันที่',
  width: '1.5fr',
  filter(val: any) {
    return useFormat.date(val).displayShortThaiDateTime();
  },
};
export const createdAt = {
  name: 'วันที่นำเข้าระบบ',
  width: '11rem',
  filter(val: any) {
    return val ? useFormat.date(val).displayShortThaiDateTime() : '';
  },
};
export const status = {
  name: 'สถานะ',
  width: '11rem',
  component: defineComponent({
    render(createElement: any) {
      return createElement(
        DeliveryStatusRenderer,
        {
          attrs: {
            status: (this as any).row.item.status,
            reason: (this as any).row.item.failureReason,
          },
          props: { row: {} },
        },
      );
    },
    props: { row: {} },
  }),
  filter: () => '',
};
export const paymentType = {
  name: 'การชำระเงิน',
  width: '8rem',
  filter: (val: string) => paymentMethodTranslate(val),
};

export const customerName = {
  name: 'ชื่อผู้รับ',
  width: '1.5fr',
};

/* eslint-disable-next-line */
export const area_id = {
  name: 'เขตจัดส่ง',
  width: '10rem',
};

export const address = {
  name: 'ที่อยู่ในการจัดส่ง',
  width: '14rem',
  filter: (val: any) => `${val.address} ${val.province?.nameInThai} ${val.district?.nameInThai ? val.district?.nameInThai : ''} ${val.subdistrict?.nameInThai ? val.subdistrict?.nameInThai : ''} ${val.zipcode}`,
};

export const totalWeight = {
  name: 'น้ำหนักรวม',
  width: '5rem',
  class: 'text-right',
  // eslint-disable-next-line
  filter: (val: string) => val ? parseFloat(String(val)).toLocaleString('th-TH', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) : 0,
};

export const deliveryFee = {
  name: 'ค่าจัดส่ง',
  width: '1fr',
  class: 'text-right',
  filter: (val: string, row: any) => useFormat.number(val || row.item.fullTruckLoadFee).currency(),
};

export const remarks = {
  name: 'หมายเหตุ',
  width: '1.5fr',
  // eslint-disable-next-line
  filter: (val: string) => val !== 'NA' ? val : '',
};

export const lastUpdatedBy = {
  name: 'ผู้ทำรายการล่าสุด',
  width: '8rem',
  // eslint-disable-next-line
  filter: (val: any) => val ? val.name : '',
};

export const updatedAt = {
  name: 'แก้ไขล่าสุด',
  width: '10rem',
  filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
  class: 'text-right',
};

export const type = {
  name: 'ประเภท',
  width: '6rem',
  filter: (val: string) => typeTranslate(val),
};

export const vehicle = {
  name: 'รถขนส่ง',
  width: '6rem',
  filter: (val: string, row: any) => row.item.deliveryNote?.vehicle?.license || 'N/A',
};

export const sortable = [
  'createdAt',
  'orderNumber',
  'orderDate',
  'status',
  'paymentType',
  'customerName',
  'updatedAt',
  'area_id',
];
